import { render, staticRenderFns } from "./StaffingFixed.vue?vue&type=template&id=8e48977c&"
import script from "./StaffingFixed.vue?vue&type=script&lang=js&"
export * from "./StaffingFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports